import 'assets/css/components/Footer.scss';
import LogoDynamate from "assets/images/logos/logo-dynamate.svg";

const Footer = (): JSX.Element => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='page-footer'>
      <div className='page-footer__inner'>

        <div className='page-footer__logo-block'>
          <a href='https://www.dynamate.be' className='page-footer__logo-link'>
            <img src={ LogoDynamate } alt='Dynamate' className='page-footer__logo-image' />
          </a>
        </div>

        <div className='page-footer__meta-block'>
          <small className='copyright'>
            &copy; { currentYear } Dynamate
          </small>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
